import { Inject, Injectable } from '@angular/core';
import { PRODUCT } from '../injection-token';
import { Product } from '../models/product.model';
import {
  DefaultActionValue,
  DefaultJourneyValue,
  SystemEventData,
  TrackEventData,
} from '../models/track-event.model';
import { ContextService } from './context.service';

declare global {
  interface Window {
    dataLayer?: Array<TrackEventData>;
  }
}

@Injectable()
export class TrackEventService {
  constructor(
    @Inject(PRODUCT) private readonly product: string,
    private readonly contextService: ContextService,
  ) {}
  trackEventData: TrackEventData = {
    event: undefined,
    journey: DefaultJourneyValue,
    action: DefaultActionValue,
    source: {},
    metadata: {},
  };

  trackEvent(data: TrackEventData): void {
    const dataValue = this.getTrackEventData(data);
    if (dataValue) {
      this.setDataLayer(dataValue);
    }
  }

  trackSystemEvent(data: SystemEventData): void {
    this.setDataLayer({ ...this.trackEventData, ...data });
  }

  private getTrackEventData(data: TrackEventData): TrackEventData | null {
    if (!data.source && this.product !== Product.Outlook) {
      data.source = {
        module: this.contextService.currentModuleId,
      };
    }
    const eventData = { ...this.trackEventData, ...data };
    eventData.event ??= [eventData.module, eventData.journey, eventData.action]
      .filter(Boolean)
      .join('_');

    return eventData;
  }

  private setDataLayer(data: TrackEventData | SystemEventData): void {
    if (this.product === Product.Outlook) {
      window.dataLayer?.push({ ...data });
    } else {
      const parent = top || window;
      parent.dataLayer = parent.dataLayer || [];
      parent.dataLayer.push({ ...data });
    }
  }
}
